/* eslint-disable ember/no-mixins, no-unused-vars */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import ReportingReviewMixin from 'linced-app/mixins/reporting-review';
import ReportingBaseMixin from 'linced-app/mixins/reporting-base';
import { tracked } from '@glimmer/tracking';

export default class ReviewController extends Controller.extend(
  ReportingReviewMixin,
  ReportingBaseMixin,
) {
  @service
  router;

  @service
  studentReportActions;

  @service
  toaster;

  @computed('parentController.editorOptions')
  get editorOptions() {
    return this.parentController.get('editorOptions');
  }

  @computed('parentController.progressChartColors')
  get progressChartColors() {
    return this.parentController.get('progressChartColors');
  }

  isSingleStudent = true;
  @tracked person = null;
  @tracked template = null;
  @tracked _captureReportVisuals = null;

  @alias('template')
  activeReport;
  @tracked _reviewRefreshFn;
  @tracked rubricDialogStudent;
  @tracked showRubricDialog;

  cleanupReviewView() {
    this._cleanupReviewState();
    this.person = null;
    this.template = null;
  }

  @action
  exitReview() {
    this.cleanupReviewView();
    this.router.transitionTo('reporting.group.student');
  }

  @action
  reviewSelectComponent(section, component) {
    this._selectReviewComponent(section, component);
  }

  @action
  closeReviewEditor() {
    this._closeReviewEditor();
  }

  @action
  async updateReviewProgressRecords() {
    let data = this.reviewProgressRecordsData;
    if (!data) return;
    await data.update().catch(() => null);
  }

  @action
  reviewUpdateJudgement(elementId, value) {
    this._updateReviewStrand('judgement', elementId, value);
  }

  @action
  reviewUpdateEffort(elementId, value) {
    this._updateReviewStrand('effort', elementId, value);
  }

  @action
  updateReviewField(value) {
    this._updateReviewField(value);
  }

  @action
  updateReviewNextStepsGoals(value) {
    this._updateReviewField(value, 'next-steps-goals');
  }

  @action
  registerReportViewCapture(fn) {
    this._captureReportVisuals = fn;
  }

  @action
  registerReviewRefresh(fn) {
    this._reviewRefreshFn = fn;
  }

  @action
  openRubricDialog(student) {
    this.rubricDialogStudent = student;
    this.showRubricDialog = true;
  }

  @action
  closeRubricDialog() {
    this.showRubricDialog = false;
    this.rubricDialogStudent = null;
  }

  @action
  async markReadyToPublish() {
    let student = this.person;
    let studentReport = this.reviewStudentReports[student.get('id')];
    if (!studentReport) return;

    if (this._captureReportVisuals) {
      await this._captureReportVisuals();
    }

    try {
      await this.studentReportActions.approve(studentReport);
      this.toaster.success('Report marked as ready to publish.');
      this.router.transitionTo(
        'reporting.group.student.view',
        studentReport.get('id'),
      );
    } catch (e) {
      this.toaster.error('Failed to approve report for publishing.');
    }
  }
}
